import { Logo } from "@components/Logo"
import { Container } from "@components/ui/Container"
import { Span } from "@components/ui/typograhpy/Span"
import { cn } from "@lib/cn"
import { DOCUMENTATION_URL } from "@lib/documentation-url"
import Link from "next/link"
import { FC } from "react"
import { AnimationVariant } from "../layout"
import { ContentPageHeaderMobileMenu } from "./MobileMenu"

export const internalLinks = [
  {
    href: "/pricing",
    title: "Pricing",
  },
]

type ContentPageHeaderProps = {
  animationVariant: AnimationVariant
}

export const ContentPageHeader: FC<ContentPageHeaderProps> = ({
  animationVariant,
}) => {
  return (
    <>
      <div className="relative h-18 w-full" />
      <nav
        className={cn(
          "bg-content-header bg-repeat-[initial] fixed top-0 left-0 z-10 w-full -translate-y-2 bg-size-[4px_4px] opacity-0 backdrop-blur-xs perspective-[1000px]",
          animationVariant === "animate" && "animate-fade-in",
          animationVariant === "visible" &&
            "translate-y-0 rotate-0 opacity-100 perspective-[1000px]",
        )}
        data-animation-variant={animationVariant}
      >
        <Container
          className="focus-visible:shadow-outline top-0 left-0 grid grid-cols-[auto_1fr] justify-between gap-4 py-4 focus-visible:rounded-[3px] focus-visible:outline-0 lg:grid-cols-[1fr_auto_1fr]"
          as="div"
        >
          <Link href="/" className="relative overflow-hidden py-2">
            <div className="hidden lg:block">
              <Logo variant="full" />
            </div>
            <div className="block lg:hidden">
              <Logo variant="icon-only" />
            </div>
          </Link>
          <div className="hidden items-center gap-8 lg:flex">
            <Span
              as="a"
              href={DOCUMENTATION_URL}
              target="blank"
              variant="button-label-small"
            >
              Docs
            </Span>
            {internalLinks.map((link) => (
              <Link href={link.href} passHref key={link.href} legacyBehavior>
                <Span as="a" variant="button-label-small">
                  {link.title}
                </Span>
              </Link>
            ))}
          </div>
          <div className="flex items-center justify-end gap-5">
            <Link href="/login" passHref legacyBehavior>
              <Span as="a" variant="button-label-small">
                Login
              </Span>
            </Link>
            <Link href="/signup/create-account" passHref legacyBehavior>
              <Span as="a" variant="button-label-small" className="ml-4">
                Try for free
              </Span>
            </Link>
            <ContentPageHeaderMobileMenu />
          </div>
        </Container>
      </nav>
    </>
  )
}
